// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";

// Custom styles for the SidenavItem
import { item, itemContent, itemArrow } from "./styles/sidenavItem";

import { useSoftUIController } from "context";
import RefKeyBadge from "./RefKeyBadge";

function SidenavItem({
  name,
  active = false,
  nested = false,
  extraIndentRem = 0,
  children = false,
  open = false,
  isAfms = false,
  refKey,
  ...rest
}) {
  const [controller] = useSoftUIController();
  const { miniSidenav } = controller;

  return (
    <>
      <ListItem {...rest} component="li" sx={item}>
        <SoftBox sx={(theme) => itemContent(theme, { active, miniSidenav, name, nested, isAfms, extraIndentRem })}>
          <ListItemText
            primary={
              <SoftBox component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
                {name}
                <RefKeyBadge refKey={refKey} />
              </SoftBox>
            }
          />
          {children && (
            <Icon component="i" sx={(theme) => itemArrow(theme, { open, miniSidenav, isAfms })}>
              expand_less
            </Icon>
          )}
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

// Typechecking props for the SidenavItem
SidenavItem.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  nested: PropTypes.bool,
  extraIndentRem: PropTypes.number,
  children: PropTypes.node,
  open: PropTypes.bool,
  isAfms: PropTypes.bool,
  refKey: PropTypes.string,
};

export default SidenavItem;
